module.exports = __webpack_public_path__ + "front/img/24.0ae22e1e.jpg";